var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"no-data"},[_c('img',{staticClass:"pictrue",attrs:{"src":require("@assets/images/no_card.png")}}),_c('div',{staticClass:"title"},[_vm._v("对不起，该练习暂无章节~")])])])
}]

export { render, staticRenderFns }